import { apiRequest } from 'utils/request'
import { getTabId } from 'utils/tabId'

export default {
  getFleet: ({ serialNumber }) =>
    apiRequest({
      uri: `/vehicles/${serialNumber}/fleet`,
    }),
  update: ({
    serialNumber,
    notes,
    ptoExclusions,
    featuresExclusions,
    setPto,
    setFeatures,
  }) =>
    apiRequest({
      uri: `/vehicles/${serialNumber}/fleet/update`,
      method: 'POST',
      headers: {
        'X-Tab-Id': getTabId(),
      },
      body: {
        notes,
        ptoExclusions,
        featuresExclusions,
        setPto,
        setFeatures,
      },
    }),
}
